// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminDistributorPriceLists = (client) => ({
    /**
     * `GET /admin/distributor-price-lists`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDistributorPriceListsList
     * @source apps/backend/src/api/admin/distributor-price-lists/route.ts
     */
    list: (query, headers) => client.fetch("/admin/distributor-price-lists", { method: "GET", query, headers }),
});
//# sourceMappingURL=distributor-price-lists.js.map